import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { ActivityRepository } from '../local-db/repositories/activity-repository';

@Injectable({ providedIn: 'root' })
export class ActivitySyncService extends SynchronizationServiceBase {
    constructor(
        injector: Injector,
        private readonly _activitieRepo: ActivityRepository
    ) {
        super(injector, SynchronizationEntity.Activities);
    }

    public async synchronize(): Promise<void> {
        await this._activitieRepo.refreshActivities();
    }
}
